import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPptURL } from '../../reduxFunction/appSlice'; 
import { getCookie, getExtension, RemoveCookie } from '../../config';

const OfficeViewer = () => {
    let fileUrl = "";
        if (getCookie('fToken')) {
            fileUrl = atob(getCookie('fToken'));
            setTimeout(() => {
                RemoveCookie('fToken')
            }, 30000);
        } else {
            fileUrl = useSelector(getPptURL);
        }
    const encodedUrl = encodeURIComponent(fileUrl);
    const viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}&wdAr=1.7777777777777777`;

    // Disable right-click and certain dev keys
    useEffect(() => {
        const disableRightClick = (e) => e.preventDefault();
        const disableShortcuts = (e) => {
            if (
                (e.ctrlKey && ['u', 'U'].includes(e.key)) ||
                (e.ctrlKey && e.shiftKey && ['i', 'I', 'j', 'J'].includes(e.key)) ||
                e.key === 'F12'
            ) {
                e.preventDefault();
            }
        };

        document.addEventListener('contextmenu', disableRightClick);
        document.addEventListener('keydown', disableShortcuts);

        return () => {
            document.removeEventListener('contextmenu', disableRightClick);
            document.removeEventListener('keydown', disableShortcuts);
        };
    }, []);

    // Fullscreen toggle function
    const goFullScreen = () => {
        const elem = document.documentElement;
        if (
            !document.fullscreenElement &&
            !document.webkitFullscreenElement &&
            !document.mozFullScreenElement &&
            !document.msFullscreenElement
        ) {
            if (elem.requestFullscreen) elem.requestFullscreen();
            else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
            else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
            else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
        } else {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
        }
    };

    
    // if (fileUrl) {
    if (fileUrl && ( getExtension(fileUrl) === 'ppt' || getExtension(fileUrl) === 'pptx' )) {
        return (
            <div>
                <style>{`
                    html, body, #root {
                        height: 100%;
                        margin: 0;
                        overflow: hidden;
                    }
                    iframe {
                        position: absolute;
                        top: -80px;
                        left: 0;
                        width: 100vw;
                        height: calc(100vh + 80px);
                        border: none;
                    }
                    .fullscreen-btn {
                        padding: 5px 10px;
                        position: fixed;
                        left: -33px;
                        transform: rotate(270deg);
                        top: 40%;
                        background: green;
                        color: white;
                        cursor: pointer;
                        z-index: 9999;
                    }
                `}</style>

                <iframe src={viewerUrl} title="Office Viewer" />

                <div className="fullscreen-btn" onClick={goFullScreen}>
                    Full Screen
                </div>
            </div>
        );
    } else {
        return (
            <div
                className='text-center mt-5'
                style={
                    {
                        width: 'fit-content',
                        margin: '0px auto',
                        border: '1px solid #dedede',
                        padding: '20px 50px',
                        paddingBottom: '70px',
                        borderRadius: '5px'
                    }
                }
            >
                <img className="mt-5" src="/logo.png" alt="Acumen Glow" title="Acumen Glow" />
                <h3 className="mt-5 mb-5 text-success">
                    The requested resources was not found on this server. That's all we know.
                </h3>
                <a href="/" className="btn btn-lg btn-info">Go to Home</a>
                &nbsp; &nbsp; &nbsp;
                <a href="/user/dashboard" className="btn btn-lg btn-danger">My Courses</a>
            </div>    
        );
    }
};

export default OfficeViewer;
